/* ==========================================================================
   TRC Final Sale · cart drawer add-on (Nov 2026)
   Loaded after trco-cart-v3-d.js by snippets/trco-cart-drawer.liquid.
   1. Shows a "Final Sale" notice under any line whose product is tagged
      `badge:finalsale` (or that already carries the "Final Sale" property).
   2. Makes sure every final-sale line carries the "Final Sale" line-item
      property, so checkout, the order confirmation and the admin order show
      it even when the item was added from an upsell or quick-add button.
   ========================================================================== */
(function () {
  'use strict';
  var T = window.__trco; if (!T) return;
  var CONFIG = T.CONFIG, esc = T.esc, postJSON = T.postJSON, Ctrl = T.Ctrl;

  var TAG = 'badge:finalsale';
  var PROP = 'Final Sale';
  var VALUE = 'No change-of-mind returns or refunds. Exchanges subject to stock availability.';
  var NOTE = 'Final Sale: no change-of-mind returns or refunds. Exchanges subject to stock availability.';

  var css = document.createElement('style');
  css.textContent =
    '.trco-item__final-sale{margin-top:6px;padding:6px 8px;border:1px solid #e3a4a4;' +
    'background:#fdf2f2;color:#9b1c1c;font-size:12px;font-weight:500;line-height:1.35;}';
  document.head.appendChild(css);

  function hasTag(self, it) {
    var p = self.productCache && self.productCache[it.handle];
    return !!(p && p.tags && p.tags.indexOf(TAG) !== -1);
  }
  function hasProp(it) { return !!(it.properties && it.properties[PROP]); }

  // Notice in the line item; hide the raw property line so it isn't shown twice.
  var origItemHTML = Ctrl.prototype.itemHTML;
  Ctrl.prototype.itemHTML = function (it) {
    var view = it;
    if (it.properties && it.properties[PROP] != null) {
      view = {};
      for (var k in it) { if (it.hasOwnProperty(k)) view[k] = it[k]; }
      var pr = {};
      for (var j in it.properties) { if (it.properties.hasOwnProperty(j) && j !== PROP) pr[j] = it.properties[j]; }
      view.properties = pr;
    }
    var html = origItemHTML.call(this, view);
    if (!hasProp(it) && !hasTag(this, it)) return html;
    var marker = '</div><div class="trco-item__right">';
    var note = '<div class="trco-item__final-sale">' + esc(NOTE) + '</div>';
    return html.indexOf(marker) === -1 ? html : html.replace(marker, note + marker);
  };

  // Add the property to final-sale lines that don't have it yet.
  function syncProps(self) {
    if (self._fsBusy || self._loading || !self.cart) return;
    var addon = CONFIG.addon && CONFIG.addon.variantId;
    self._fsTried = self._fsTried || {};
    var todo = (self.cart.items || []).filter(function (it) {
      if (it.variant_id === addon || it.id === addon) return false;
      return hasTag(self, it) && !hasProp(it) && !self._fsTried[it.key];
    });
    if (!todo.length) return;
    var chain = Promise.resolve();
    todo.forEach(function (it) {
      self._fsTried[it.key] = true;
      chain = chain.then(function () {
        var props = {};
        for (var k in (it.properties || {})) { if (it.properties.hasOwnProperty(k)) props[k] = it.properties[k]; }
        props[PROP] = VALUE;
        return postJSON('cart/change.js', { id: it.key, quantity: it.quantity, properties: props });
      }).catch(function () {});
    });
    self._fsBusy = chain.then(function () {
      self._fsBusy = null;
      return self.refresh(false);
    });
  }

  var origRender = Ctrl.prototype.render;
  Ctrl.prototype.render = function () {
    var r = origRender.apply(this, arguments);
    window.__trcoFinalSaleCtrl = this;
    syncProps(this);
    return r;
  };

  // If the customer hits Checkout while a line is being updated, wait for it.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-trco-checkout]');
    var c = window.__trcoFinalSaleCtrl;
    if (!btn || !c || !c._fsBusy) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    c._fsBusy.then(function () { window.location.href = T.url('checkout'); });
  }, true);
})();
